import { Container } from "pixi.js"
import Clock from "./Clock"

export default class FadingContainer extends Container {
  fadeDuration: number

  constructor(params: { x: number, y: number, fadeDuration?: number }) {
    super({
      x: params.x,
      y: params.y
    })

    this.alpha = 0
    this.fadeDuration = params.fadeDuration || 200

    this.fadeIn()
  }

  fadeIn() {
    const intervalTime = 10
    const alphaIncrement = 1 / (this.fadeDuration / intervalTime)

    const interval = Clock.setInterval(() => {
      this.alpha += alphaIncrement
      if (this.alpha >= 1) {
        this.alpha = 1
        this.onFadeInComplete()
        Clock.clear(interval)
      }
    }, intervalTime)
  }

  fadeOut() {
    const intervalTime = 10
    const alphaIncrement = 1 / (this.fadeDuration / intervalTime)
    const interval = Clock.setInterval(() => {
      this.alpha -= alphaIncrement
      if (this.alpha <= 0) {
        this.alpha = 0
        this.onFadeOutComplete()
        Clock.clear(interval)
      }
    }, intervalTime)
  }

  onFadeInComplete() {
    // Override this method
  }

  onFadeOutComplete() {
    // Override this method
  }
}
